import { render, staticRenderFns } from "./FullTrade.vue?vue&type=template&id=5a84d8d2&scoped=true"
import script from "./FullTrade.vue?vue&type=script&lang=js"
export * from "./FullTrade.vue?vue&type=script&lang=js"
import style0 from "./FullTrade.vue?vue&type=style&index=0&id=5a84d8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84d8d2",
  null
  
)

export default component.exports